import api from './api';

const doctorService = {
  /** ADMIN roster: paginated, @Roles('admin'). Only the Providers admin page may use this. */
  getDoctors: (params) => api.get('/admin/doctors', { params }),

  /**
   * THE PROVIDER PICKER (CL-260824-08). Active providers only, and NOT admin-guarded.
   *
   * Same defect as the product picker: order forms called the admin roster, so a sales_rep or
   * clinic login got a 403 and the dropdown rendered empty with no error.
   */
  getActiveDoctors: () => api.get('/doctors'),
  getDoctorById: (id) => api.get(`/admin/doctors/${id}`),
  createDoctor: (data) => api.post('/admin/doctors', data),
  updateDoctor: (id, data) => api.put(`/admin/doctors/${id}`, data),
  deleteDoctor: (id) => api.delete(`/admin/doctors/${id}`),
};

export default doctorService;
